import { useTheme } from '@emotion/react'

export function useProduct() {
    const { kind } = useTheme()
    return kind
}
